<template>
  <div>
    <base-header type="gradient-success" class="pb-5 pt-5 pt-md-8">
      <b-media class="text-center ml-5 mr-5">
      </b-media>
    </base-header>
    <div class="container-fluid mt--7">

      <b-row>
        <b-col col lg="12">
          <b-card no-body>
            <div class="card shadow">
              <div class="card-header bg-transparent">
                <div>
                  <h3 class="float-left mb-0">
                    {{ $tc('message.followUp') }}
                  </h3>
                </div>

                <div class="card-body pl-0">
                  <section class="container-fluid" id="followup">
                    <!-- DESIGN PURPOSE ROW -->
                    <!-- This row is important because it remove one desired effect -->
                    <div class="row">
                      <div class="col-lg-12">
                        <p></p>
                      </div>
                    </div>
                    <!-- END OF DESIGN PURPOSE ROW -->
                    <div class="row">
                      <div class="col-lg-12 followup-header my-2 mb-4 pl-0">
                        <b-button @click="onGoBack" class="">
                          <i class="fa fa-reply edit-icon"></i>
                          {{ $t('message.back') }}
                        </b-button>
                        <b-button @click="onAddClick" class="followup-add">
                          <i class="fa fa-plus edit-icon"></i>
                          {{ $t('message.add') }}
                        </b-button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-9 followup-category">
                        <div class="row mb-3">
                          <div class="col-md-6">
                            <h1 class="followup-category-title">
                              {{ followUpCategory.nom }}
                            </h1>
                          </div>
                          <div v-if="followUpArray.length > 0" class="col-md-6">
                            <div class="d-inline-block ml-1">
                              <b-input-group
                                  size="md"
                                  class="mb-3"
                              >
                                <b-form-input
                                    type="text"
                                    size="lg"
                                    class="p-2 h-100"
                                    :placeholder="$t('message.searchPatient') + '...'"
                                    v-model="filterCriteria"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-button
                                      size="sm"
                                      text="Button"
                                      variant="primary"
                                  >
                                    <i class="fa fa-search"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </div>
                          </div>
                        </div>

                        <div :class="`row ${followUpArray.length === 0 ? 'p-3' : ''}`">
                          <template
                              v-if="followUpArray.length > 0"
                          >
                            <div
                                v-for="followUpItem in followUpArray"
                                :key="followUpItem.id"
                                class="col-md-4 mb-4"
                            >
                              <div class="followup-card-item-wrapper">
                                <div class="followup-card-item">
                                  <div
                                      class="title"
                                      @click="onGoToMedicalFile(followUpItem.dossier.slug)"
                                  >
                                    <p >{{ followUpItem.dossier.patient.user.nom }}</p>
                                  </div>
                                  <div class="message">
                                    <p>{{ followUpItem.motifs }}</p>
                                  </div>
                                  <div
                                      @click="toggleShowOption(followUpItem.id)"
                                      class="threedot"
                                      :id="'show-option-' + followUpItem.id"
                                  >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                  </div>
                                  <div
                                      :id="'show-option-container-' + followUpItem.id"
                                      class="followup-action"
                                  >
                                    <a @click="onShowFollowedUp(followUpItem)">{{ $t('message.show') }}</a>
                                    <a @click="onEditClick(followUpItem.slug)">{{ $t('message.edit') }}</a>
                                    <a @click="handleOnClickOnDelete(followUpItem.slug)">{{ $t('message.delete') }}</a>
                                  </div >
                                  <div class="label-container">
                                    <div
                                        class="label bg-primary text-white "
                                        :id="'followup-todo-list-ongoing-' + followUpItem.id"
                                        @click="onClickShowTodoList(followUpItem)"
                                    >
                                      <i class="fa fa-list"></i>
                                    </div>

                                    <div
                                        v-if="hasToDoList(followUpItem)"
                                        class="toDoLabel"
                                    >
                                      <!--                                        bg-${getToDoColor(followUpItem)}-->

                                      <i class="fa fa-circle "
                                         :style="`color:${getToDoColor(followUpItem)}`"
                                      ></i>
                                    </div>

                                    <b-popover
                                        :target="'followup-todo-list-ongoing-' + followUpItem.id"
                                        triggers="hover"
                                        placement="top"
                                    >
                                      <template v-slot:title>
                                        {{ $t('message.todoList') }}
                                      </template>
                                    </b-popover>
                                  </div>

                                  <div class="followup-switcher">
                                    <b-button :id="'followup-switcher-ongoing-' + followUpItem.id" class="followup-switcher--btn">
                                      <i class="fa fa-arrows-alt-h"></i>
                                    </b-button>

                                    <b-popover
                                        :target="'followup-switcher-ongoing-' + followUpItem.id"
                                        triggers="hover"
                                        placement="top"
                                    >
                                      <template v-slot:title>{{ $t('message.moveQuestion') }}</template>
                                      <template
                                          v-for="(categoryItem, key) in followUpCategories"
                                      >
                                        <template v-if="categoryItem.slug !== followUpCategory.slug">
                                          <a
                                              :key="key"
                                              class="followup-switcher--link"
                                              href="#"
                                              @click="onMoveFollowedUp(followUpItem, categoryItem.id)"
                                          >
                                            {{ categoryItem.nom }}
                                          </a>
                                          <template v-if="key !== followUpCategories.length - 1">
                                            &nbsp; | &nbsp;
                                          </template>
                                        </template>
                                      </template>
                                    </b-popover>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>

                          <template v-else>
                            <p class="mt-2">
                              <i>{{ $t('message.noItem') }}</i>
                            </p>
                          </template>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="category-group">
                          <div
                              v-for="(categoryItem, key) in followUpCategories"
                              :key="key"
                              :class="`category-item ${categoryItem.slug === followUpCategorySlug ? 'colored' : ''}`"
                              @click="categoryItem.slug !== followUpCategorySlug ? goToOneCategory(categoryItem.slug) : null"
                          >
                            <span></span>
                            <p>
                              {{ capitalize(categoryItem.nom) }}
                            </p>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="row appointment-table-footer">

                    </div>
                  </section>
                  <section>
                    <b-modal
                        id="delete-followedUp"
                        size="sm"
                        header-bg-variant="danger"
                        header-text-variant="light"
                        :title="$t('message.delete') + ' ' + $t('message.followUp')"
                        hide-footer
                    >
                      <div class="d-block text-center">
                        <h3>{{ $t('message.deleteConfirmation') }}</h3>
                      </div>

                      <div class="d-block float-right">
                        <b-button variant="secondary" @click="$bvModal.hide('delete-followedUp')">
                          {{ $t('message.cancel') }}
                        </b-button>

                        <b-button variant="danger" @click="deleteFollowedUp">
                          {{ $t('message.delete') }}
                        </b-button>
                      </div>
                    </b-modal>
                  </section>

                  <section>
                    <b-modal
                        id="todo-list"
                        size="lg"
                        header-bg-variant="primary"
                        header-text-variant="light"
                        :title="$t('message.todoList')"
                        hide-footer
                    >
                      <div class="row">
                        <div class="col-md-6">
                          <div class="d-inline-block ml-1">
                            <!--<b-button
                                    size="sm"
                                    text="Button"
                                    variant="primary"
                                    @click="onAddTodoItem"
                            >
                                <i class="fa fa-plus"></i>
                            </b-button>-->
                            <b-input-group
                                size="md"
                                class="mb-3"
                            >
                              <b-form-input
                                  type="text"
                                  size="lg"
                                  class="p-2 h-100"
                                  :placeholder="$t('message.add') + '...'"
                                  v-model="newTodoItemTitle"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                    size="sm"
                                    text="Button"
                                    variant="primary"
                                    @click="onAddTodoItem"
                                >
                                  <i class="fa fa-plus"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </div>
                        </div>
                      </div>
                      <div class="row todo-list">
                        <template
                            v-if="followedUpTodoList && followedUpTodoList.to_do_list.length > 0"
                        >
                          <ul
                              v-for="(todoItem, key) in followedUpTodoList.to_do_list"
                              :key="key"
                              class="todo-item checklist col-12"
                          >
                            <li>
                              <input
                                  type="checkbox"
                                  name="tall"
                                  :id="'todo-item-' + todoItem.id"
                              >
                              <label
                                  :for="'todo-item-' + todoItem.id"
                                  :class="`${isTdoItemChecked(todoItem) ? 'todo-item-done' : ''}`"
                              >
                                <i
                                    @click="toggleTodoItemCheckStatus(todoItem)"
                                    :class="`action-toggler fa ${isTdoItemChecked(todoItem) ? 'fa-check-square' : 'fa-square'}`"
                                ></i>
                                <input
                                    type="text"
                                    class="todo-item-intitule"
                                    @blur="event => updateField(event.target.value, todoItem, 'intitule')"
                                    :value="todoItem.intitule"
                                >
                                <div class="action-list">
                                  <i class="action-description fa fa-chevron-left"></i>
                                  <i
                                      @click="deleteTodoItem(todoItem)"
                                      class="action-delete fa fa-trash"
                                  ></i>
                                </div>
                              </label>
                              <ul>
                                <li>
                                  <label class="description-label">
                                                                        <textarea
                                                                            type="text"
                                                                            class="todo-item-description"
                                                                            @blur="event => updateField(event.target.value, todoItem, 'description')"
                                                                            :placeholder="$t('message.addDescriptionHere')"
                                                                        >{{todoItem.description}}</textarea>
                                  </label>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </template>
                        <template v-else>
                          <div class="col-md-12">
                            <p class="mt-2">
                              <i>{{ $t('message.noItem') }}</i>
                            </p>
                          </div>
                        </template>
                      </div>

                      <div class="d-block float-right mt-3">
                        <b-button variant="secondary" @click="$bvModal.hide('todo-list')">
                          {{ $t('message.ok') }}
                        </b-button>
                      </div>
                    </b-modal>

                    <b-modal
                        id="followup-item"
                        size="lg"
                        header-bg-variant="primary"
                        header-text-variant="light"
                        :title="$t('message.followUp')"
                        hide-footer
                    >
                      <div
                          v-if="shownFollowedUp"
                          class="container followup-item-display"
                      >
                        <div class="row">
                          <div class="col-lg-3">
                            <p class="label">
                              {{ $t('message.nomPatient') }}
                            </p>
                          </div>
                          <div class="col-lg-9">
                            <p
                                class="content patient-name"
                                @click="onGoToMedicalFile(shownFollowedUp.dossier.slug)"
                            >
                              {{ shownFollowedUp.dossier.patient.user.nom }}
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <p class="label">
                              {{ $t('message.doctorName') }}
                            </p>
                          </div>
                          <div class="col-lg-9">
                            <p
                                class="content"
                            >
                              {{ getManagerName(shownFollowedUp.responsable) }}
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <p class="label">
                              {{ $tc('message.reasons',1) }}
                            </p>
                          </div>
                          <div class="col-lg-9">
                            <p class="content">
                              {{ shownFollowedUp.motifs }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <!--<div v-else>
                          No item selected
                      </div>-->
                    </b-modal>
                  </section>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal
        id="rendez-vous"
        size="lg"
        header-bg-variant="primary"
        :title="$tc('message.appointments',1)"
        hide-footer
    >
      <div class="d-block text-center">
        <b-form class="mt-4">
          <b-container>
            <b-row>
              <b-col md="12" sm="12">
                <p class="text-left">
                  <span class="obligatoire">*</span>
                  <span >Date de consultation</span>
                </p>

                <vue-ctk-date-time-picker class="border-dark" v-model="$v.appointment.date.$model"></vue-ctk-date-time-picker>
                <span class="custom-invalid" v-if="$v.appointment.date.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" sm="12" class="mt-3">
                <b-form-group
                    id="motif-group"
                    :label="$tc('message.reasons',1)"
                    label-for="motif"
                    class="text-left">
                  <b-form-textarea
                      id="motif"
                      v-model="$v.appointment.motifs.$model"
                      :state="$v.appointment.motifs.$dirty ? !(errorshasField('motifs') || $v.appointment.motifs.$error) : null"
                      placeholder=""
                  ></b-form-textarea>
                  <b-form-invalid-feedback v-if="errorshasField('motifs')">
                    {{ getErrorsField('motifs') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="$v.appointment.motifs.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" sm="12">
                <b-form-group
                    id="isConsultantDoctor-group"
                    :label="$t('message.isConsultantDoctor')"
                    label-for="isConsultantDoctor"
                    class="text-left">
                  <b-form-radio
                      v-model="$v.appointment.isConsultantDoctor.$model"
                      name="isConsultantDoctor"
                      value="true"
                      :inline="true"
                  >
                    {{ $t('message.yes') }}
                  </b-form-radio>
                  <b-form-radio
                      v-model="$v.appointment.isConsultantDoctor.$model"
                      name="isConsultantDoctor"
                      value="false"
                      :inline="true"
                  >
                    {{ $t('message.no') }}
                  </b-form-radio>
                  <b-form-invalid-feedback v-if="errorshasField('isConsultantDoctor')">
                    {{ getErrorsField('isConsultantDoctor') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="$v.appointment.isConsultantDoctor.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                </b-form-group>

              </b-col>
            </b-row>
            <b-row v-if="appointment.isConsultantDoctor === 'false'" class="mt-3">
              <b-col md="12" sm="12">
                <b-form-group
                    id="consultantDoctor-group"
                    :label="$t('message.select')+' '+$tc('message.medecin',1)"
                    label-for="patient"
                    class="text-left">

                  <b-form-radio
                      v-model="$v.appointment.medecinSource.$model"
                      name="medecinSource"
                      value="fromMedicasure"
                      :inline="true"
                  >
                    {{ $t('message.fromMedicasure') }}
                  </b-form-radio>
                  <b-form-radio
                      v-model="$v.appointment.medecinSource.$model"
                      name="medecinSource"
                      value="fromOthers"
                      :inline="true"
                  >
                    {{ $t('message.fromOthers') }}
                  </b-form-radio>
                  <!-- Options -->
                  <v-select
                      v-if="appointment.medecinSource === 'fromMedicasure'"
                      id="consultantDoctor"
                      class="form-control is-invalid retirerBordure"
                      :reduce="praticien => praticien.id"
                      v-model="$v.appointment.praticien_id.$model"
                      :options="mContributors"
                      label="nom"
                      required />

                  <!--                                                                <select-->
                  <!--                                                                        v-if="form.medecinSource === 'fromMedicasure'"-->
                  <!--&lt;!&ndash;                                                                        id="consultantDoctor"&ndash;&gt;-->
                  <!--                                                                        v-model="$v.form.practicien_id.$model"-->
                  <!--                                                                        class="form-control is-invalid border-light mt-2"-->
                  <!--                                                                >-->
                  <!--                                                                    <option v-for="item in mContributors" :value="item.id" :key="item.id">-->
                  <!--                                                                        {{ item.nom }}-->
                  <!--                                                                    </option>-->
                  <!--                                                                </select>-->

                  <b-form-input
                      id="doctorName"
                      class="mt-2"
                      v-else
                      v-model="$v.appointment.doctorName.$model"
                      :placeholder="$t('message.preciseDoctorName')"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
      </div>

      <div class="d-block float-right">
        <b-button variant="primary" @click="bookingAppointment">
          {{ $t('message.save') }}
        </b-button>

        <b-button variant="secondary" @click="closeModal">
          {{ $t('message.cancel') }}
        </b-button>


      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import * as _ from "lodash";
import router from '../../router/router';
import moment from "moment";
import Swal from 'sweetalert2';
import {required} from 'vuelidate/lib/validators';
import Vue from "vue";


export default {
  name: "FollowUpCategory",
  computed: {
    ...mapGetters([
      "followed",
      "followUpCategories",
      "followUpCategory",
      "practitioners",
      "controlDoctors",

    ]),

    mPractitioners: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
        let p = {};
        if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
          let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
          prenom =  prenom.toLowerCase();
          p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          p.id = practitioner.user.id;
          if (p.nom.length >0){
            pArray.push(p);
          }
        }

      });

      return pArray;
    },

    mDoctors: function() {
      let dArray = [];

      _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
        let d = {};
        if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
          let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
          prenom =  prenom.toLowerCase();
          d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          d.id = doctor.user.id;

          if (d.nom.length >0){
            dArray.push(d);
          }
        }

      });

      return dArray;
    },

    mContributors:function () {
      let cArray = [];
      return cArray.concat(this.mDoctors,this.mPractitioners);
    }
  },

  data() {
    return {
      appointment:{
        isConsultantDoctor: 'true',
        doctorName: '',
        medecinSource: 'fromMedicasure',
        date:'',
        praticien_id:'',
        patient_id:'',
        motifs:'',
        statut:'Programmé'
      },
      followedUpTodoList: null,
      newTodoItemTitle: '',
      newTodoItemDescription: '',
      filterCriteria: '',
      followUpArray: [],
      shownFollowedUp: null,
      followUpCategorySlug: this.$route.params.followUpCategorySlug,
    };
  },
  watch: {
    followed: function (newFollowed, oldFollowed) {

    },
    followUpCategory: function (n, o) {
      // console.log('followUpCategory => ', n);
      const result=[];
      _.forEach(n.suivis, function (suivi) {
        if(suivi.dossier!==null)
        result.push(suivi);
      })
      // console.log('result => ', result);
      this.followUpArray = result.sort((a, b) => moment(b.dossier.updated_at).format('x') - moment(a.dossier.updated_at).format('x'));
    },
    followUpCategories: function (n, o) {
      // console.log('followUpCategories => ', n);
    },
    filterCriteria: function (newValue, oldValue) {
      this.handleFilter(newValue);
    },
    shownFollowedUp: function (n ,o) {
      // console.log('shownFollowedUp => ', n);
    }
  },
  methods: {
    hasToDoList(followUp){
      return followUp.to_do_list.length != 0;
    },

    getToDoColor(followUp){
        if (_.every(followUp.to_do_list,['statut','undone'])){
          return '#F5365C';
        }
        else if(_.every(followUp.to_do_list,['statut','done'])){
          return 'green';
        }

        return '#FFAC14';

    },

    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };
      // if(this.hasPraticienRole || this.hasMedecinControleRole || this.hasAdminRole){
      this.$store.dispatch('getControlDoctors', { args : args });
      // }
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };
      // if(this.hasPraticienRole || this.hasMedecinControleRole || this.hasAdminRole) {
      this.$store.dispatch('getPractitioners', {args: args});
      // }
    },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },

    bookingAppointment(){
      event.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid ) {
        const args = {};

        // Perform task about practicien or medecine name

        if (this.appointment.isConsultantDoctor === 'true') {
          let practicien = null;
          if (this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante){
            practicien = JSON.parse(localStorage.getItem('user'))['id'];
          }
          args.praticien_id = practicien;
        } else if (this.appointment.medecinSource === 'fromMedicasure') {
          args.praticien_id = this.appointment.praticien_id;
        } else {
          args.praticien_id = this.appointment.doctorName;
        }

        // Parse it to string
        args.praticien_id = '' + args.praticien_id;

        args.date = moment(this.appointment.date).format('YYYY-MM-DD HH:mm');
        args.patient_id = this.appointment.patient_id;
        args.motifs = this.appointment.motifs;
        args.statut = 'Programmé';

        const successMessage = this.$i18n.t('message.appointmentMade');
        const errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        const actionToPerform = 'makeAppointment';

        const payload = { args, errorMessages, successMessage };

        this.$store.dispatch(actionToPerform, payload).then(() => {
          Vue.swal(
              this.$i18n.t('message.followedUpUpdated' ),
              '',
              'success'
          );
          this.closeModal();
        });
      }
    },
    closeModal(){
      this.$bvModal.hide('rendez-vous');
    },

    capitalize(text) {
      return _.capitalize(text);
    },
    onGoToMedicalFile(slug) {
      router.push({ name: 'medical-file', params: {file: slug} });
    },

    getSpecialitiesName: function (specialities) {
      return specialities.map(item => item.specialite.name).join(', ');
    },

    onShowFollowedUp(followedUp) {
      this.shownFollowedUp = followedUp;
      setTimeout(() => {
        this.$bvModal.show('followup-item');
      }, 500);
    },

    getManagerName(managers) {
      const _managers = managers.map(m => {
        const result = [m.praticien.nom];
        if (m.praticien.prenom) result.push(m.praticien.prenom);
        return result.join(' ');
      });

      return _managers.join(', ');
    },

    toggleShowOption(id) {
      const element = document.getElementById(`show-option-${id}`);
      const elementContainer = document.getElementById(`show-option-container-${id}`);
      if (element && elementContainer) {
        element.classList.toggle('opened');
        elementContainer.classList.toggle('opened');
      }
    },

    onMoveFollowedUp(followedUp, destination) {
      event.preventDefault();
      const state = destination;

      const element = JSON.parse(JSON.stringify(followedUp));
      element.categorie_id = state;
      // element.responsable = element.responsable.id;

      this.updateFollowedUp(element);
    },

    updateFollowedUp(newFollowedUp) {
      const successMessage = this.$i18n.t('message.followedUpUpdated' );
      const errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      let suivi = { ...newFollowedUp };
      let dossier = suivi.dossier;
      let responsables = suivi.responsable;

      delete suivi.dossier;
      delete suivi.responsable;

      let praticiens = [];

      _.forEach(responsables, function (responsable) {
        praticiens.push({id:responsable.user_id})
      })

      let args = suivi;
      args.dossier_medical_id = dossier.id;
      args.responsable = praticiens;
      args.slugToRedirect = this.followUpCategorySlug;

      const payload = { args, slug: newFollowedUp.slug, errorMessages, successMessage };
      this.$store.dispatch('updateFollowUp', payload).then(() => {
        this.removeFollowUpItemFromFollowUpCategory(newFollowedUp);
        if (suivi.categorie_id == 6){
          let self = this;
          Swal.fire({
            title: self.$i18n.tc('message.appointments', 2),
            icon: 'info',
            html: self.$i18n.t('message.organiserRdv'),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: true,
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
            cancelButtonColor: '#f5365c',
          }).then((result) => {
            if (result.value) {
              self.$bvModal.show('rendez-vous');
              self.appointment.patient_id = newFollowedUp.dossier.patient_id;
              self.appointment.praticien_id = JSON.parse(localStorage.getItem('user'))['id'];
              self.appointment.date =(moment(Date.now()).add(6,'M').format('YYYY-MM-DD HH:mm'));
              self.appointment.isConsultantDoctor = 'true';
            }else{
              Vue.swal(
                  this.$i18n.t('message.followedUpUpdated' ),
                  '',
                  'success'
              );
            }
          });
        }
        // this.getFollowUpCategory();
      });
    },

    removeFollowUpItemFromFollowUpCategory(followUp) {
      const currentFollowUpCategory = JSON.parse(JSON.stringify(this.followUpCategory));

      currentFollowUpCategory.suivis = currentFollowUpCategory.suivis.filter(item => item.slug !== followUp.slug);

      this.$store.dispatch('updateFollowUpCategories', currentFollowUpCategory);
    },

    handleOnClickOnDelete(slug) {
      this.followedUpToDelete = slug;
      this.$bvModal.show('delete-followedUp');
    },

    deleteFollowedUp() {
      const successMessage = this.$i18n.t('message.followedUpDeleted' );
      const errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      const refreshArray = (followedUp) => {
        const currentFollowUpCategory = _.cloneDeep(this.followUpCategory);

        currentFollowUpCategory.suivis = currentFollowUpCategory.suivis.filter(f => f.id !== followedUp.id);

        this.$store.dispatch('updateFollowUpCategories', currentFollowUpCategory).then(() => {
          // this.followedUpTodoList = followUp;
        });
      };

      const payload = {
        args: {},
        slug: this.followedUpToDelete,
        errorMessages,
        successMessage,
        refreshArray
      };

      this.$store.dispatch('deleteFollowUp', payload).then(() => {
        this.$bvModal.hide('delete-followedUp');
        this.followedUpToDelete = '';
        // this.getListOfFollowUp();
      });
    },

    onClickShowTodoList(followUpItem) {
      this.followedUpTodoList = followUpItem;
      this.$bvModal.show('todo-list');
    },

    onAddTodoItem() {
      event.preventDefault();
      if (this.newTodoItemTitle !== '') {
        const args = {};
        args.listable_type = 'Suivi';
        args.listable_id = this.followedUpTodoList.id;
        args.intitule = this.newTodoItemTitle;
        args.description = '';
        args.statut = 'undone';

        const successMessage = this.$i18n.t('message.todoItemCreated');
        const errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        const actionToPerform = 'createTodoItem';

        const refreshArray = (todoItem, followUpId) => {
          const currentFollowUpCategory = _.cloneDeep(this.followUpCategory);

          const followUp = currentFollowUpCategory.suivis.find(f => f.id === followUpId);

          followUp.to_do_list.unshift(todoItem);

          this.$store.dispatch('updateFollowUpCategories', currentFollowUpCategory).then(() => {
            this.followedUpTodoList = followUp;
            this.newTodoItemTitle = '';
          });
        };

        const payload = { args, errorMessages, successMessage, refreshArray };

        this.$store.dispatch(actionToPerform, payload).then(() => {

        });
      }
    },

    toggleTodoItemCheckStatus(todoItem) {
      event.preventDefault();
      const newTodoItem = _.cloneDeep(todoItem);
      newTodoItem.statut = !this.isTdoItemChecked(todoItem) ? 'done' : 'undone';
      this.updateTodoItem(newTodoItem);
    },

    isTdoItemChecked(todoItem) {
      return todoItem.statut === 'done';
    },

    updateField(value, todoItem, field) {
      if (value !== '' && value !== todoItem[field]) {
        const newTodoItem = _.cloneDeep(todoItem);
        newTodoItem[field] = value;
        this.updateTodoItem(newTodoItem);
      }
    },

    updateTodoItem(todoItem) {
      event.preventDefault();

      if (todoItem.intitule !== '') {
        const args = {};
        args.listable_type = todoItem.listable_type;
        args.listable_id = todoItem.listable_id;
        args.intitule = todoItem.intitule;
        args.description = todoItem.description;
        args.statut = todoItem.statut;

        const successMessage = this.$i18n.t('message.followedUpCreated');
        const errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        const refreshArray = (todoItem, followUpId) => {
          const currentFollowUpCategory = _.cloneDeep(this.followUpCategory);

          const followUp = currentFollowUpCategory.suivis.find(f => f.id === followUpId);

          followUp.to_do_list = followUp.to_do_list.map(item => item.id === todoItem.id ? todoItem : item);

          this.$store.dispatch('updateFollowUpCategories', currentFollowUpCategory).then(() => {
            this.followedUpTodoList = followUp;
          });
        };

        const payload = {
          args,
          slug: todoItem.slug,
          errorMessages,
          successMessage,
          shouldSentNotification: false,
          refreshArray,
        };

        this.$store.dispatch('updateTodoItem', payload).then(() => {

        });
      }
    },

    deleteTodoItem(todoItem) {
      event.preventDefault();

      const args = {};

      const successMessage = this.$i18n.t('message.todoItemDeleted');
      const errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      const refreshArray = (_todoItem, followUpId) => {
        const currentFollowUpCategory = _.cloneDeep(this.followUpCategory);

        const followUp = currentFollowUpCategory.suivis.find(f => f.id === followUpId);

        followUp.to_do_list = followUp.to_do_list.filter(item => item.id !== _todoItem.id);

        this.$store.dispatch('updateFollowUpCategories', currentFollowUpCategory).then(() => {
          this.followedUpTodoList = followUp;
        });
      };

      const payload = {
        args,
        slug: todoItem.slug,
        errorMessages,
        successMessage,
        refreshArray,
      };

      this.$store.dispatch('deleteTodoItem', payload).then(() => {
        refreshArray(todoItem, todoItem.listable_id);
      });
    },

    getListOfFollowUp(){
      this.$store.dispatch('getFollowed', {args: {}});
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.errorshasField(field);
    },

    onAddClick() {
      event.preventDefault();
      router.push({ name: 'add-follow-up' });
    },

    onGoBack() {
      event.preventDefault();
      router.go(-1);
      // router.push({ name: 'add-follow-up' });
    },

    onEditClick(slug) {
      event.preventDefault();
      router.push({ name: 'edit-follow-up', params: {followedUp: slug} });
    },

    // getFollowUp(){
    //     let args = {
    //         // Replace the suivi value by the slug to be recovered in back
    //         suivi: 'value-of-the-follow-up'
    //     };
    //
    //     this.$store.dispatch("getFollowUp", { args });
    // }

    goToOneCategory(slug) {
      router.push({ name: 'follow-up-category', params: {followUpCategorySlug: slug} });
      this.getFollowUpCategory();
      this.followUpCategorySlug = this.$route.params.followUpCategorySlug
      // this.getListOfFollowUpCategories();
    },

    handleFilter(value) {
      if (value && value !== '') {
        this.followUpArray = this.followUpArray.filter(app => {
          let result = false;
          if (app.motifs) {
            result = result || app.motifs.toLowerCase().includes(value.toLowerCase())
          }

          if (app.dossier.patient.user.nom) {
            result = result || app.dossier.patient.user.nom.toLowerCase().includes(value.toLowerCase())
          }

          if (app.dossier.patient.user.prenom) {
            result = result || app.dossier.patient.user.prenom.toLowerCase().includes(value.toLowerCase())
          }

          return result;
        });
      } else {
        this.followUpArray = this.followUpCategory.suivis;
      }
    },

    getFollowUpCategory() {
      const args = {
        categorie: this.$route.params.followUpCategorySlug
      };
      const errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      this.$store.dispatch('getFollowUpCategory', { args, errorMessages });
    },
    getListOfFollowUpCategories(){
      this.$store.dispatch('getFollowUpCategories', {args: {}});
    },
  },
  mounted() {
    this.getFollowUpCategory();
    this.getListOfFollowUpCategories();
    // this.getFollowUp();
    this.getDoctors();

    // Fetch practitioner list
    this.getPractitioners();
  },

  validations() {
    return {
      appointment:{
        isConsultantDoctor: {required},
        medecinSource: {},
        date: {required},
        praticien_id:{required},
        patient_id:{required},
        motifs: {},
        statut: {},
        doctorName: {}
      },
    }
  }
}
</script>

















<style scoped lang="scss">
$primary-color: #2dcecc;
$gray-color: #ebecf0;
$white: #fff;
$black: #121212;

.toDoLabel {
  border-radius: 25px;
  padding: 1px 5px;
  display: inline-block;
  margin-left: 4px;
  cursor: pointer;
}
.bg-red {
  background: #F5365C;
}

.bg-orange {
  background: #FFAC14;
}

.bg-green {
  background: green;
}

#followup {
  .followup-content {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    overflow: hidden;
    overflow-x: scroll;
  }

  .followup-wrapper {
    /*width: 800px;*/
    /*min-width: 800px;*/
    /*max-width: 800px;*/
    /*overflow: hidden;*/
    /*overflow-x: auto;*/
  }

  .followup-header {
    button {
      border-radius: 30px;
    }
    .followup-add {
      background: $primary-color;
      color: $white;
      padding: 7px 25px;
      border: none;

      i {
        color: $white;
      }
    }
  }

  .followup-column {
    display: inline-block;
    background: $gray-color;
    padding: 10px 5px;
    width: 250px;
    /*width: 30%;*/
    border-radius: 20px;
    vertical-align: top;
    border: 1px solid rgba(0, 0, 0, 0.2);

    &-content {
      height: 310px;
      min-height: 310px;
      max-height: 310px;
      overflow: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 5px;
      }

      &::-webkit-scrollbar-track {
        /*box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);*/
      }

      &::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        outline: 1px solid slategrey;
        border-radius: 15px;
      }
    }

    .followup-column-title p {
      color: $black;
      text-align: center;
      font-size: 1.0625rem;
      position: relative;

      &:first-letter {
        text-transform: uppercase;
      }

      &:after {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: calc(50% - 10px);
        width: 20px;
        height: 1px;
        background: $primary-color;
      }
    }

    .followup-card-item {
      $padding-left: 15px;

      position: relative;
      background: $white;
      padding: $padding-left;
      margin: 0 10px 20px;
      /*width: 225px;*/

      border-radius: 9px;
      border: .5px solid rgba(0, 0, 0, .1);
      box-shadow: 0px 0px 17px 0px rgba(82, 83, 105, 0.05);

      p {
        margin-bottom: 0;
      }

      .title {
        margin-bottom: 4px;
        position: relative;
        cursor: pointer !important;

        &:hover {
          cursor: pointer !important;
        }

        &:after {
          content: ' ';
          position: absolute;
          bottom: 0;
          left: -1%;
          width: 100%;
          height: 1px;
          background: #8080807d;
        }
      }

      .message {
        p {
          color: #808080ab;
          font-size: 15px;
          white-space: nowrap;
          width: 144px;
          text-overflow: ellipsis;
          overflow: hidden;
          margin-bottom: 10px;
        }
      }

      .threedot {
        position: absolute;
        top: 0;
        right: $padding-left;
        cursor: pointer;

        /*.threedot-link {
            span {
                display: inline-block;
                width: 8px;
                height: 8px;
                background: $primary-color;
                margin-left: 3px;
                border-radius: 50%;
            }

            &:hover ~ .followup-action {
                right: 0;
                opacity: 1;
            }
        }*/

        span {
          display: inline-block;
          width: 4px;
          height: 4px;
          background: $primary-color;
          margin-left: 3px;
          border-radius: 50%;
        }

        &.opened {
          span {
            background: #44cb8c;
            border-color: $black;
          }

          .followup-action {
            right: 0;
            opacity: 1;
            display: block;
          }
        }

        .followup-action {
          background: $white;
          position: absolute;
          top: 25px;
          right: -100px;
          opacity: 0;
          transition: all .3s;
          z-index: 999;
          display: none;

          a {
            color: $black;
            display: block;
            padding: 5px 15px;
            transition: all .3s;
            font-weight: 600;

            &:hover {
              background: $gray-color;
              color: $primary-color;
            }
          }
        }
      }

      .label-container {
        position: absolute;
        bottom: -10px;
        right: 15px;
        max-height: 25px;
        max-width: 140px;
        overflow: hidden;

        .label {
          background: $primary-color;
          border-radius: 25px;
          padding: 1px 5px;
          display: inline-block;
          margin-left: 4px;
          cursor: pointer;

          p {
            font-size: 0.8rem;
            color: white;
            font-weight: 600;
            white-space: nowrap;
            width: 13px;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: center;
          }
        }
      }

      .followup-switcher {
        position: absolute;
        bottom: -10px;
        left: 0;
        max-height: 25px;
        max-width: 25px;
        overflow: hidden;

        .followup-switcher--btn {
          background: $primary-color;
          border-radius: 50%;
          padding: 1px 5px;
          cursor: pointer;

          i {
            color: $white;
          }
        }
      }
    }
  }

  .f-first {
    margin-right: 20px;
  }

  .f-second {
    margin-right: 20px;
  }

  .f-third {

  }
}

.followup-category-title {
  &:first-letter {
    text-transform: uppercase;
  }
}

.followup-card-item-wrapper {
  background: transparent;
  /*margin-right: 10px;*/
  /*padding: 10px 10px 20px;*/
  /*box-shadow: 0px 2px 5px 0px;*/
}

.followup-card-item {
  $padding-left: 15px;

  position: relative;
  background: $white;
  padding: $padding-left;
  /*border: 0.5px solid rgba(0, 0, 0, 0.1);*/
  border-radius: 9px;
  box-shadow: 0px 0px 17px 0px rgba(82, 83, 105, 0.05);

  /*margin: 0 10px;*/
  /*margin-bottom: 20px;*/
  /*width: 225px;*/

  p {
    margin-bottom: 0;
  }

  .title {
    margin-bottom: 4px;
    position: relative;

    &:first-letter {
      text-transform: uppercase;
    }

    &:hover {
      cursor: pointer !important;
    }

    &:after {
      content: ' ';
      position: absolute;
      bottom: 0;
      left: -1%;
      width: 100%;
      height: 1px;
      background: #8080807d;
    }

    p {
      color: $primary-color;
    }
  }

  .message {
    p {
      color: #808080ab;
      font-size: 15px;
      white-space: nowrap;
      width: 144px;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-bottom: 10px;
    }
  }

  .threedot {
    position: absolute;
    top: 0;
    right: $padding-left;
    cursor: pointer;

    /*.threedot-link {
        span {
            display: inline-block;
            width: 8px;
            height: 8px;
            background: $primary-color;
            margin-left: 3px;
            border-radius: 50%;
        }

        &:hover ~ .followup-action {
            right: 0;
            opacity: 1;
        }
    }*/

    span {
      display: inline-block;
      width: 4px;
      height: 4px;
      background: $primary-color;
      margin-left: 3px;
      border-radius: 50%;
    }

    &.opened {
      span {
        background: #44cb8c;
        border-color: $black;
      }

    }


  }

  .followup-action {
    background: $white;
    position: absolute;
    top: 25px;
    right: -100px;
    opacity: 0;
    transition: all .3s;
    z-index: 999;
    display: none;

    a {
      color: $black;
      display: block;
      padding: 5px 15px;
      transition: all .3s;
      font-weight: 600;
      cursor: pointer;

      &:hover {
        background: $gray-color;
        color: $primary-color;
      }
    }

    &.opened {
      right: 0;
      opacity: 1;
      display: block;
    }
  }

  .label-container {
    position: absolute;
    bottom: -10px;
    right: 15px;
    max-height: 25px;
    max-width: 140px;
    overflow: hidden;

    .label {
      background: $primary-color;
      border-radius: 25px;
      padding: 1px 5px;
      display: inline-block;
      margin-left: 4px;
      cursor: pointer;

      p {
        font-size: 0.8rem;
        color: white;
        font-weight: 600;
        white-space: nowrap;
        width: 13px;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
      }
    }
  }

  .followup-switcher {
    position: absolute;
    bottom: -10px;
    left: 0;
    max-height: 25px;
    max-width: 25px;
    overflow: hidden;
    border-radius: 50%;

    .followup-switcher--btn {
      background: $primary-color;
      border-radius: 50%;
      padding: 1px 5px;
      cursor: pointer;

      i {
        color: $white;
      }
    }
  }
}

.followup-switcher--link {
  font-weight: bold;
  margin-bottom: 10px;
}

.followup-item-display {
  .label {
    font-weight: bold;
  }

  .label,
  .content {
    &:first-letter {
      text-transform: uppercase;
    }
  }

  .patient-name {
    color: $primary-color;

    &:hover {
      cursor: pointer;
    }
  }
}

.followup-category,
.category-group {
  border: 1px solid $primary-color;
  border-radius: 10px;
  padding: 1rem;
  background: #f8f9fe;
}

.followup-category {
  max-height: 400px;
  overflow: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);*/
  }

  &::-webkit-scrollbar-thumb {
    background-color: $primary-color !important;
    outline: 1px solid slategrey;
    border-radius: 20px;
  }
}

.category-group {
  /*height: 100%;*/

  .category-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;

    &:hover {
      span {
        background: #2dcecc;
        border: 0.5px solid rgba(0, 0, 0, 0.2);
      }
      p {
        color: #2dcecc;
      }

    }

    span {
      width: 20px;
      height: 20px;
      background: white;
      border: 0.5px solid rgba(0, 0, 0, 0.2);
      margin-right: 10px;
      display: inline-block;
      border-radius: 50%;
    }

    p {
      display: inline-block;
      margin-bottom: 0 !important;
    }

    &.colored {
      span {
        background: #2dcecc;
        border: 0.5px solid rgba(0, 0, 0, 0.2);
      }
      p {
        color: #2dcecc;
      }
    }
  }
}

.todo-list {
  .todo-item {
    input[type=checkbox]{
      display:none
    }

    &,
    ul{
      padding: 0;
      margin: 0;
      overflow: hidden;
    }

    li{
      padding-left: 27px;
      position: relative;
      font-size: 1rem;
      margin-top: 4px;
      display: flex;
      flex-direction: column;

      input:nth-of-type(1):checked ~ ul{
        max-height: 1000px;
      }

      label{
        padding: 16px 25px;
        background-color: #f3f3f4;
        /*   cursor: pointer; */
        border-radius: 100px;
        height: 25px;
        font-size: 13px;
        display: flex;
        align-items: center;

        &.description-label {
          height: 80px;
        }

        &.todo-item-done {
          border: 2px solid $primary-color;
        }

        i {
          font-size: 20px;
          cursor: pointer;

          &.action-toggler {
            color: $primary-color;
          }
        }

        & > span{
          margin: 0 20px;
        }

        input[type=text]
        ,textarea {
          flex: 1;
          color: #676A6C;
          background: white;
          border: none;
          border-radius: 3px;
          transition: .2s ease;
          padding: 9px;
          margin-left: 15px;
          margin-right: 15px;
          background: none;

          &:focus,
          &:hover{
            background: white;
            height: 25px;
            outline: rgba(0, 0, 0, .2) solid 0.5px;
          }

          &.todo-item-intitule {
            color: #32325d;
            font-weight: 600;
            font-size: 14px;
          }
        }

        textarea {
          overflow: hidden;
          overflow-wrap: break-word;
          resize: none;
          height: 60px;
        }

        &:not(.child) .action-description{
          transition: .3s ease;
        }
      }

      input[type=checkbox]:checked + label .action-description{
        transform: rotate(-90deg);
      }
    }

    & > li{
      padding-left: 0;
    }

    ul{
      max-height: 0;
      -webkit-transition: .8s ease;
      -moz-transition: .8s ease;
      -ms-transition: .8s ease;
      -o-transition: .8s ease;
    }

    .action-list{
      margin-left: auto;

      i {
        margin-right: 10px;
      }

      .action-delete {
        font-size: 18px;

        &:hover {
          color: red;
        }
      }
    }
  }
}
</style>
